import DatePicker from 'react-date-picker';
import styled from 'styled-components';

import { ButtonStyled } from '../Button/Button.styled';

type CalendarPropsT = {
  isOpen: boolean;
  bottomIndent?: number;
};

export const DatePickerWrapperStyled = styled.div`
  position: relative;
`;

export const CalendarContainerStyled = styled.div<CalendarPropsT>`
  border: 1px solid #a0a096;
  position: absolute;
  z-index: 2;
  background: #fff;
  display: flex;
  flex-direction: column;

  ${({ theme, isOpen, bottomIndent }) => `
    ${!isOpen ? 'visibility: hidden;' : null};
    bottom: ${bottomIndent}px;

    .react-date-picker__calendar {
      .react-calendar {
        border: none;
      }

      .react-calendar, .react-calendar__month-view__days__day--weekend {
        color: ${theme.textColour};
      }

      .react-calendar__tile--now {
        background: transparent;
      }

      .react-calendar__tile--active {
        background: ${theme.primaryColour};
        color: ${theme.whiteColour};
      }
    }
  `}

  ${ButtonStyled} {
    margin: 5px auto;
  }
`;

export const DatePickerStyled = styled(DatePicker)`
  ${({ theme }) => `
    &.react-date-picker {
      width: 100%;
      height: 42px;
      border: 1px solid ${theme.borderColour};
      border-radius: 4px;

      .react-date-picker__wrapper{
        padding: 8px;
        color: ${theme.textColour};
        border: none;
      }

      .react-date-picker__inputGroup__input {
        color: ${theme.textColour};
      }

      .react-date-picker__calendar-button:hover {
        .react-date-picker__calendar-button__icon {
          stroke: ${theme.primaryColour};
        }
      }

      .react-date-picker__inputGroup {
        font-weight: ${theme.fontWeights.light};
      }
    }

    .react-date-picker__calendar {
      .react-calendar, .react-calendar__month-view__days__day--weekend {
        color: ${theme.textColour};
      }

      .react-calendar__tile--now {
        background: transparent;
      }

      .react-calendar__tile--active {
        background: ${theme.primaryColour};
        color: ${theme.whiteColour};
      }
    }

    &.react-date-picker--open {
      border: 1px solid ${theme.primaryColour};

      .react-date-picker__calendar-button__icon {
        stroke: ${theme.primaryColour};
      }
    }
  `}
`;
